import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import * as MyPOSEmbedded from 'mypos-embedded-checkout';
import { DeliverService, NServices, ServiceRequest } from "../../web-api-client";
import { environment } from "../../../environments/environment";

@Component({
  selector: 'app-mpost-pay',
  templateUrl: './mpost-pay.component.html',
  styleUrls: ['./mpost-pay.component.scss'],
})
export class MPostPayComponent implements OnInit {

  @Input() serviceRequest: ServiceRequest;
  @Input() deliverService: DeliverService;
  @Input() amount: number;
  @Output() paymentStatus: EventEmitter<boolean> = new EventEmitter<boolean>();

  ngOnInit(): void {
    var paymentParams = {
      sid: environment.mpostSid,
      ipcLanguage: 'bg', // Checkout page language (ISO 2 format).
      walletNumber: environment.mpostWalletNumber,
      amount: this.amount,
      currency: 'BGN',
      orderID: this.generateOrderId(),
      urlNotify: MyPOSEmbedded.IPC_URL + '/client/ipcNotify', // Warning: use your own url to verify your payment!
      urlOk: window.location.href, // Optional - required only for iDeal
      urlCancel: window.location.href, // Optional - required only for iDeal
      keyIndex: 1,
      cartItems: []
    };

    paymentParams.cartItems = [];
    paymentParams.cartItems.push({
      article: this.deliverService.service.serviceName,
      quantity: 1,
      price: this.amount,
      currency: 'BGN',
    });

    var callbackParams = {
      isSandbox: true,
      onSuccess: (data) => {
        console.log('success callback');
        console.log(data);
        this.paymentStatus.emit(true);
      },
      onError: () => {
        console.log('error');
        this.paymentStatus.emit(false);
      }
    };

    MyPOSEmbedded.createPayment(
      'embeddedCheckout',
      paymentParams,
      callbackParams
    );
  }

  generateOrderId(): string {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // getMonth() returns month from 0 to 11
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  }

}
